module.exports = __webpack_public_path__ + "img/app.78092947.png";